var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fx-list',{staticStyle:{"height":"100%","overflow":"auto"},attrs:{"show-search":"","show-refresher":"","show-result":"","title":"Utilisateurs","item-renderer":_vm.itemRenderer,"url":_vm.urlRessourceEndPoint}})}
var staticRenderFns = []

export { render, staticRenderFns }